/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteComputeSecretRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteComputeSecretRequest$inboundSchema: z.ZodType<
  DeleteComputeSecretRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteComputeSecretRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteComputeSecretRequest$outboundSchema: z.ZodType<
  DeleteComputeSecretRequest$Outbound,
  z.ZodTypeDef,
  DeleteComputeSecretRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteComputeSecretRequestToJSON(
  deleteComputeSecretRequest: DeleteComputeSecretRequest,
): string {
  return JSON.stringify(
    DeleteComputeSecretRequest$outboundSchema.parse(deleteComputeSecretRequest),
  );
}
export function deleteComputeSecretRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteComputeSecretRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteComputeSecretRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteComputeSecretRequest' from JSON`,
  );
}
